/** @file Spacing scale aligned with MUI's 8px multiplier for coexistence. */

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '40px'
};
